<template>
    <div class="dashboard">
      <EnergyDashboard />
    </div>
  </template>
  
  <script setup>
  import EnergyDashboard from '../components/EnergyDashboard.vue'
  </script>
  
  <style lang="scss" scoped>
  .dashboard {
    // Additional dashboard styles if needed
  }
  </style>